import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from 'react-router-dom';
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../Components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import DeleteModal from '../../../Components/Common/DeleteModal';
import personEntity from '../../../assets/images/svg/personEntity.svg';

import { Col, Row, UncontrolledTooltip, Modal, ModalHeader, ModalBody, Form, Input, FormFeedback, Label, Card, CardBody, Button } from "reactstrap";

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import "flatpickr/dist/themes/material_green.css";
import Spinners from "Components/Common/Spinner";

import { useLegalEntityFindAllQuery, useLegalEntityCreateMutation, useLegalEntityUpdateMutation, useLegalEntityDeleteMutation } from '../../../store';
import { numberWithCommas } from "../../../helpers/globalHelper"

const Detail = () => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [isLoading, setLoading] = useState(true)

  const [modal, setModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [legalEntity, setLegalEntity] = useState<any>(null);
  const [legalEntityList, setLegalEntityList] = useState<any>();
  const [personEntityCount, setPersonEntityCount] = useState();

  const { data, error, isFetching } = useLegalEntityFindAllQuery(customQuery);
  const [entityCreate, entityCreateResult] = useLegalEntityCreateMutation();
  const [entityUpdate, entityUpdateResult] = useLegalEntityUpdateMutation();
  const [entityDelete, entityDeleteResult] = useLegalEntityDeleteMutation();

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();


  useEffect(() => {
    setLoading(false)
    setLegalEntityList(data?.data)
    setPersonEntityCount(legalEntityList?.length)

    setCustomPagination(data?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1}&pageSize=${customPageSize !== undefined ? customPageSize : 25}`;
    setCustomQuery(tempQuery)
  }, [legalEntityList, data, customPageSize, customPageLength, customPagination])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setLegalEntity(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleLegalEntityClick = useCallback((arg: any) => {
    const legalEntity = arg;
    setLegalEntity({
      id: legalEntity.id,
      type_id: legalEntity.type_id,
      register: legalEntity.register,
      mname: legalEntity.mname,
      fname: legalEntity.fname,
      lname: legalEntity.lname,
      gender: legalEntity.gender,
      phone_no: legalEntity.phone_no,
      phone_no2: legalEntity.phone_no2,
      email: legalEntity.email,
      au1: legalEntity.au1,
      au2: legalEntity.au2,
      au3: legalEntity.au3,
      address: legalEntity.address
    });
    setIsEdit(true);
    toggle();
  }, [toggle]);

  //delete LegalEntity
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (legalEntity) => {
    setLegalEntity(legalEntity);
    setDeleteModal(true);
  };

  const handleDeletelegalEntity = () => {
    if (legalEntity) {
      toastr.success("Мэдээлэл амжилттай устгагдлаа!", "Амжилттай");
      entityDelete(legalEntity.id);
      setDeleteModal(false);
    }
  };
  const handleLegalEntityClicks = () => {
    setIsEdit(false);
    setLegalEntity(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
        }
      },
      {
        header: "Овог",
        accessorKey: "lname",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Нэр',
        accessorKey: "fname",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Регистерийн дугаар',
        accessorKey: "register",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Хуулийн төрөл',
        accessorKey: "type_id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          switch (cellProps.row.original.type_id) {
            case 10:
              return <span className="badge badge-soft-success fw-semibold fs-6 text">Иргэн</span>;
            default:
              return <span className="badge badge-soft-primary fw-semibold fs-6 text"> Хуулийн этгээд </span>;
          }
        },
      },
      {
        header: 'Утасны дугаар',
        accessorKey: "phone_no",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'Нэмэлт утасны дугаар',
        accessorKey: "phone_no2",
        enableColumnFilter: false,
        enableSorting: false,
      },

      {
        header: 'Үйлдэл',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              {/* <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link to="/legalEntity-details" className="btn btn-sm btn-soft-primary">
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i></Link>
              </li>
              <UncontrolledTooltip placement="top" target="viewtooltip">
                View
              </UncontrolledTooltip> */}

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={(event: any) => {
                    const legalEntityData = cellProps.row.original;
                    event.preventDefault();
                    handleLegalEntityClick(legalEntityData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                  </UncontrolledTooltip>
                </Link>
              </li>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const legalEntityData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(legalEntityData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>

          );
        }
      },
    ],
    [handleLegalEntityClick]
  );

  const validation: any = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: legalEntity?.id,
      type_id: legalEntity?.type_id,
      register: legalEntity?.register,
      mname: legalEntity?.mname,
      fname: legalEntity?.fname,
      lname: legalEntity?.lname,
      gender: legalEntity?.gender,
      phone_no: legalEntity?.phone_no,
      phone_no2: legalEntity?.phone_no2,
      email: legalEntity?.email,
      au1: legalEntity?.au1,
      au2: legalEntity?.au2,
      au3: legalEntity?.au3,
      address: legalEntity?.address
    },
    validationSchema: Yup.object({
      fname: Yup.string().required("Нэр оруулна уу !!!"),
      lname: Yup.string().required("Овог оруулна уу !!!"),
      register: Yup.string().required("Регистерийн дугаар оруулна уу !!!"),
    }),
    onSubmit: (values: any) => {

      if (isEdit) {
        const updateLegalEntityList = {
          id: legalEntity ? legalEntity.id : 0,
          type_id: values.type_id,
          register: values.register,
          mname: values.mname,
          fname: values.fname,
          lname: values.lname,
          gender: values.gender,
          phone_no: values.phone_no,
          phone_no2: values.phone_no2,
          email: values.email,
          au1: values.au1,
          au2: values.au2,
          au3: values.au3,
          address: values.address
        };
        entityUpdate(updateLegalEntityList)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай үүслээ!", "Амжилттай");
          })
          .catch((error) => {
            toastr.error("Амжилтгүй!", "Амжилтгүй");
          })
        validation.resetForm();
      } else {
        const newLegalEntityList = {
          type_id: values["type_id"],
          register: values["register"],
          mname: values["mname"],
          fname: values["fname"],
          lname: values["lname"],
          gender: values["gender"],
          phone_no: values["phone_no"],
          phone_no2: values["phone_no2"],
          email: values["email"],
          au1: values["au1"],
          au2: values["au2"],
          au3: values["au3"],
          address: values["address"]
        };
        toastr.success("Амжилттай мэдээлэл нэмэгдлээ!", "Амжилттай");
        entityCreate(newLegalEntityList);
        validation.resetForm();
      }
      toggle();
    },
  });


  return (
    <React.Fragment>
      <DeleteModal
        deleteName={legalEntity?.fname}
        show={deleteModal}
        onDeleteClick={handleDeletelegalEntity}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Row>
        <Col lg={12}>

          <Card>
            <CardBody className="border-bottom">
              <div className="d-flex align-items-center">
                <img src={personEntity} alt="" height="50" />
                <div className="flex-grow-1 ms-3">
                  <h5 className="fw-semibold">Мэдээлэл</h5>
                  <ul className="list-unstyled hstack gap-2 mb-0">
                    <li>
                      <i className="mdi mdi-table-row-height"></i> <span className="text-muted fw-semibold">Нийт: {numberWithCommas(personEntityCount)}</span>
                    </li>
                  </ul>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    handleLegalEntityClicks();
                  }}
                  className="btn btn-success  btn-label"
                >
                  <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
                </button>
              </div>
            </CardBody>
            <CardBody>
              {
                isLoading ? <Spinners setLoading={setLoading} />
                  :
                  <TableContainer
                    setCustomPageSize={setCustomPageSize}
                    setCustomPageLength={setCustomPageLength}
                    customPagination={customPagination}
                    columns={columns}
                    data={legalEntityList || ""}
                    isCustomPageSize={true}
                    // isGlobalFilter={true}
                    isPagination={true}
                    colWidth={2}
                    SearchPlaceholder="Хэрэглэгч хайх . . ."
                    tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
              }
            </CardBody>
          </Card>

        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">
          {!!isEdit ? "Бүртгэл засах" : "Бүртгэл нэмэх"}
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col xs={12}>
                <div className="mb-3">
                  <Label>Ургийн овог</Label>
                  <Input
                    name="mname"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.mname || ""}
                    invalid={
                      validation.touched.mname && validation.errors.mname ? true : false
                    }
                  />
                  {validation.touched.mname && validation.errors.mname ? (
                    <FormFeedback type="invalid">{validation.errors.mname}</FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Овог</Label>
                  <Input
                    name="lname"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.lname || ""}
                    invalid={
                      validation.touched.lname && validation.errors.lname ? true : false
                    }
                  />
                  {validation.touched.lname && validation.errors.lname ? (
                    <FormFeedback type="invalid">{validation.errors.lname}</FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Нэр</Label>
                  <Input
                    name="fname"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.fname || ""}
                    invalid={
                      validation.touched.fname && validation.errors.fname ? true : false
                    }
                  />
                  {validation.touched.fname && validation.errors.fname ? (
                    <FormFeedback type="invalid">{validation.errors.fname}</FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Регистерийн дугаар</Label>
                  <Input
                    name="register"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.register || ""}
                    invalid={
                      validation.touched.register && validation.errors.register ? true : false
                    }
                  />
                  {validation.touched.register && validation.errors.register ? (
                    <FormFeedback type="invalid">{validation.errors.register}</FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label> Бүртгэлийн төрөл </Label>
                  <Input
                    name="type_id"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.type_id || ""}
                    invalid={
                      validation.touched.type_id && validation.errors.type_id ? true : false
                    }
                  >
                    <option value="" disabled> Сонгох </option>
                    <option value="10"> Иргэн </option>
                    <option value="40"> Хуулийн этгээд </option>
                  </Input>
                  {validation.touched.type_id && validation.errors.type_id ? (
                    <FormFeedback type="invalid">{validation.errors.type_id}</FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label> Хүйс </Label>
                  <Input
                    name="gender"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.gender || ""}
                    invalid={
                      validation.touched.gender && validation.errors.gender ? true : false
                    }
                  >
                    <option value="" disabled> Сонгох </option>
                    <option value="1"> Эрэгтэй </option>
                    <option value="0"> Эмэгтэй </option>
                  </Input>
                  {validation.touched.gender && validation.errors.gender ? (
                    <FormFeedback type="invalid">{validation.errors.gender}</FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Утасны дугаар</Label>
                  <Input
                    name="phone_no"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phone_no || ""}
                    invalid={
                      validation.touched.phone_no && validation.errors.phone_no ? true : false
                    }
                  />
                  {validation.touched.phone_no && validation.errors.phone_no ? (
                    <FormFeedback type="invalid">{validation.errors.phone_no}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Утасны дугаар</Label>
                  <Input
                    name="phone_no2"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phone_no2 || ""}
                    invalid={
                      validation.touched.phone_no2 && validation.errors.phone_no2 ? true : false
                    }
                  />
                  {validation.touched.phone_no2 && validation.errors.phone_no2 ? (
                    <FormFeedback type="invalid">{validation.errors.phone_no2}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Цахим шуудан</Label>
                  <Input
                    name="email"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ""}
                    invalid={
                      validation.touched.email && validation.errors.email ? true : false
                    }
                  />
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Хаяг</Label>
                  <Input
                    name="address"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.address || ""}
                    invalid={
                      validation.touched.address && validation.errors.address ? true : false
                    }
                  />
                  {validation.touched.address && validation.errors.address ? (
                    <FormFeedback type="invalid">{validation.errors.address}</FormFeedback>
                  ) : null}
                </div>
                {/* <div className="mb-3">
                      <Label>Хуулийн төрөл</Label>
                      <Input
                        name="experience"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={
                          validation.values.experience || ""
                        }
                        invalid={
                          validation.touched.experience && validation.errors.experience ? true : false
                        }
                      />
                      {validation.touched.experience && validation.errors.experience ? (
                        <FormFeedback type="invalid">{validation.errors.experience}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Компаний нэр</Label>
                      <Input
                        name="position"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.position || ""}
                        invalid={
                          validation.touched.position && validation.errors.position ? true : false
                        }
                      />
                      {validation.touched.position && validation.errors.position ? (
                        <FormFeedback type="invalid">{validation.errors.position}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Утасны дугаар</Label>
                      <Input
                        name="position"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.position || ""}
                        invalid={
                          validation.touched.position && validation.errors.position ? true : false
                        }
                      />
                      {validation.touched.position && validation.errors.position ? (
                        <FormFeedback type="invalid">{validation.errors.position}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Аймаг/Нийслэл</Label>
                      <Input
                        name="type"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={
                          validation.values.type || ""
                        }
                        invalid={
                          validation.touched.type && validation.errors.type ? true : false
                        }
                      >
                        <option>Архангай</option>
                        <option>Баян-Өлгий</option>
                        <option>Баянхонгор</option>
                        <option>Булган</option>

                      </Input>
                      {validation.touched.type && validation.errors.type ? (
                        <FormFeedback type="invalid">{validation.errors.type}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Сум/Дүүрэг</Label>
                      <Input
                        name="type"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={
                          validation.values.type || ""
                        }
                        invalid={
                          validation.touched.type && validation.errors.type ? true : false
                        }
                      >
                        <option>Баянзүрх</option>
                        <option>Багахангай</option>
                        <option>Сүхбаатар</option>
                        <option>Сонгино Хайрхан</option>

                      </Input>
                      {validation.touched.type && validation.errors.type ? (
                        <FormFeedback type="invalid">{validation.errors.type}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Баг/Хороо</Label>
                      <Input
                        name="type"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={
                          validation.values.type || ""
                        }
                        invalid={
                          validation.touched.type && validation.errors.type ? true : false
                        }
                      >
                        <option>1-р хороо</option>
                        <option>2-р хороо</option>
                        <option>3-р хороо</option>
                        <option>4-р хороо</option>

                      </Input>
                      {validation.touched.type && validation.errors.type ? (
                        <FormFeedback type="invalid">{validation.errors.type}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Төлөв</Label>
                      <Input
                        name="status"
                        type="select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={
                          validation.values.status || ""
                        }
                        invalid={
                          validation.touched.status && validation.errors.status ? true : false
                        }
                      >
                        <option>Нээлттэй</option>
                        <option>New</option>
                        <option>Close</option>
                      </Input>
                      {validation.touched.status && validation.errors.status ? (
                        <FormFeedback status="invalid">{validation.errors.status}</FormFeedback>
                      ) : null}
                    </div> */}
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <Button type="submit" color="success" className="save-user" > Save</Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}

export default Detail;